import { ref, watch } from "vue";
import useLoadingStore from "@shared-stores/loading.store";

/**
 * @deprecated La pile de chargement globale disparaît, fichier par fichier, quand on le touche :
 * - chargement d'un écran (`loadingStart("init")`, `isKeyLoading("init")`) → `useAsyncResource` (`isLoading`, `reload`) ;
 * - action sur un bouton (`save`, `delete`…) → un `useAsyncAction()` par geste (`isRunning`, `run`).
 */
export default function ()
{
	const loadingStore = useLoadingStore();
	const isLoading = ref<boolean>(loadingStore.isLoading);

	watch(
		() => loadingStore.isLoading,
		() =>
		{
			isLoading.value = loadingStore.isLoading;
		}
	);

	const loadingStart = loadingStore.enableLoading;
	const loadingEnd = loadingStore.disableLoading;
	const isKeyLoading = loadingStore.isKeyLoading;

	return {
		isLoading,
		loadingStore,
		loadingStart,
		loadingEnd,
		isKeyLoading
	};
}
